function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useRecoilValue } from 'recoil';
import { themeState } from '../theme';
export function Name(_ref) {
  let {
    data,
    ...props
  } = _ref;
  const theme = useRecoilValue(themeState);
  return /*#__PURE__*/React.createElement("label", _extends({}, props, {
    style: {
      // fontWeight: 'bolder',
      color: theme.keyColor,
      ...props.style
    }
  }), String(data));
}